module.exports = __webpack_public_path__ + "static/media/benchmark-banner-arc.61183442.jpg";